import { ApiGetRequest } from '../../api';

export const state = {
  data: {
    total_dist: 0,
    loading_dist: false,
    total_sales: 0,
    loading_sales: false,
    total_prod: 0,
    loading_prod: false,
    total_purchase: 0,
    loading_purchase: false,
    loading_chart: false,
    top_distributor: [],
    loading_top: false,
    chartData: {
      series: [
        {
          name: 'Sales',
          data: [],
        },
        {
          name: 'Purchase',
          data: [],
        },
      ],
      chartoptions: {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#f1b44c', '#f44336', '#03a9f4'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
      },
    },
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getTotalDistributor({ commit }) {
    commit('changeDashboard', {
      loading_dist: true,
    });

    let result = await ApiGetRequest(`dashboard/dist`);
    commit('changeDashboard', {
      total_dist: result.data.error ? 0 : result.data.object,
      loading_dist: false,
    });

    return !result.error ? true : false;
  },

  async getTotalProduct({ commit }) {
    commit('changeDashboard', {
      loading_prod: true,
    });

    let result = await ApiGetRequest(`dashboard/prod`);
    commit('changeDashboard', {
      total_prod: result.data.error ? 0 : result.data.object,
      loading_prod: false,
    });

    return !result.error ? true : false;
  },

  async getTotalSales({ commit }) {
    commit('changeDashboard', {
      loading_sales: true,
    });

    let result = await ApiGetRequest(`dashboard/sales`);
    commit('changeDashboard', {
      total_sales: result.data.error ? 0 : result.data.object,
      loading_sales: false,
    });

    return !result.error ? true : false;
  },

  async getTotalPurchase({ commit }) {
    commit('changeDashboard', {
      loading_purchase: true,
    });

    let result = await ApiGetRequest(`dashboard/purchase`);
    commit('changeDashboard', {
      total_purchase: result.data.error ? 0 : result.data.object,
      loading_purchase: false,
    });

    return !result.error ? true : false;
  },

  async getChartDashboard({ commit, state }) {
    commit('changeDashboard', {
      loading_chart: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`dashboard/chart`);
    commit('changeDashboard', {
      chartData: {
        ...data.chartData,
        series: [
          {
            name: 'Sales',
            data: !result.error ? result.data.object.sales : [],
          },
          {
            name: 'Purchase',
            data: !result.error ? result.data.object.purchase : [],
          },
        ],
      },
      loading_chart: false,
    });

    return !result.error ? true : false;
  },

  async getTopDistributor({ commit }) {
    commit('changeDashboard', {
      loading_top: true,
    });

    let result = await ApiGetRequest(`dashboard/top-distributor`);
    commit('changeDashboard', {
      top_distributor: !result.error ? result.data.object : [],
      loading_top: false,
    });

    return !result.error ? true : false;
  },
};
